module.exports = __webpack_public_path__ + "static/media/040.b72805a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/040.jpg
// module id = 386
// module chunks = 0